import { ExternalLinkIcon, HistoryIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { VERSIONS_DOCS_URL } from '@/util/constants';

interface EmptyVersionsProps {
  onCreateVersion: () => void;
  canWrite: boolean;
}

export const EmptyVersions = ({ onCreateVersion, canWrite }: EmptyVersionsProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <HistoryIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('versions.empty_title')}</EmptyTitle>
        <EmptyDescription>{t('versions.empty_description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={onCreateVersion} disabled={!canWrite}>
          {t('common.publish')}
        </Button>

        <a
          href={VERSIONS_DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 hover:underline"
        >
          <span className="text-sm leading-6 font-medium">{t('common.learn_more')}</span>
          <ExternalLinkIcon className="h-4 w-4 text-foreground-muted" />
        </a>
      </EmptyContent>
    </Empty>
  );
};
